(function () {
    'use strict';
    angular.module('Services').service('ApprovedReportTableService', ApprovedReportTableService);
    ApprovedReportTableService.$inject = [
        '$q',
        'toastr',
        'TableLiteFactory',
        '$location',
        'AffiliateService',
        '$rootScope',
        '$filter'
    ];

    function ApprovedReportTableService(
        $q,
        toastr,
        TableLiteFactory,
        $location,
        AffiliateService,
        $rootScope,
        $filter
    ) {
        return function () {
            const tableData = {
                optionAddOns: {
                    buttons: [{
                        class: 'btn-success',
                        label: 'Export CSV',
                        tooltip: 'Export CSV',
                        onClick: function () {
                            const ids = [];
                            tableData.data.forEach(item => {
                                if (item.isSelected === true) {
                                    ids.push(item.id)
                                }
                            })
                            // if(!ids.length){
                            //     toastr.warning('Please Select  At Least One Report');
                            //     return;
                            // }
                            AffiliateService.exportApprovedCSV(ids, 'Approved',
                                res => {
                                    toastr.success('Exporting Successfully');
                                    download(res, 'approved-reports.csv');
                                }, err => {

                                })
                        }
                    }, {
                        class: 'btn-primary',
                        label: 'Run CSV Transactional Summary',
                        tooltip: 'Run CSV Transactional Summary',
                        onClick: function () {
                            const ids = [];
                            tableData.data.forEach(item => {
                                if (item.isSelected === true) {
                                    ids.push(item.id)
                                }
                            })
                            AffiliateService.exportCSV(
                                res => {
                                    download(res, 'export-run-csv.csv');
                                    toastr.success('RUN CSV  Generated Successfully');
                                }, err => {

                                }, ids, {
                                'reportApproval.commissionStatus': 'Approved'
                            })
                        }
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    noExtract: true,

                },
                headers: [
                    {
                        label: 'SELECT',
                        class: 'text-center',
                        width: '75px',
                        filter: {
                            type: 'checkbox'
                        }
                    },
                    {
                        label: 'Partner Name',
                        viewName: 'name',
                        filterName: 'companyMarketing.name',
                        width: '200px',
                        filter: {
                            type: 'autoComplete',
                            placeholder: 'Search',
                            filterBy: 'name',
                            items: [],
                            onSubmit: header => {

                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            },
                            refresh: function (model) {
                                const defer = $q.defer();
                                let filterItems = this.items;
                                AffiliateService.getAllcompanyPartners(
                                    data => {
                                        angular.forEach(data.content, (item) => {
                                            filterItems.push(item);
                                        });
                                        defer.resolve();

                                    }, err => {
                                        defer.reject();
                                    }, { size: 30, name: model, sort: 'id,asc' }
                                )
                                return defer.promise;
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Partner Phone.',
                        viewName: 'phone',
                        filterName: 'companyMarketing.phone1',
                        // filter: {
                        //     type: 'select2',
                        //     placeholder: 'Search',
                        //     onSubmit: header => {
                        //         sendRequest(evaluateFilter(header));
                        //     }
                        // },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Client Name',
                        viewName: 'clientName',
                        width: '200px',
                        filterName: 'companyReferred.companyName',
                        filter: {
                            type: 'autoComplete',
                            placeholder: 'Search',
                            items: [],
                            onSubmit: header => {
                                sendRequest(evaluateFilter(header));
                            },
                            refresh: function (model) {
                                const defer = $q.defer();
                                let filterItems = this.items;
                                AffiliateService.getAllcompanyReferred(
                                    data => {
                                        angular.forEach(data.content, (item) => {
                                            filterItems.push(item.companyName);
                                        });
                                        defer.resolve();

                                    }, err => {
                                        defer.reject();
                                    }, { size: 30, companyName: model }
                                )
                                return defer.promise;
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Client Phone.',
                        viewName: 'clientPhone',
                        filterName: 'companyReferred.phone1',
                        // filter: {
                        //     type: 'select2',
                        //     placeholder: 'Search',
                        //     onSubmit: header => {
                        //         sendRequest(evaluateFilter(header));
                        //     }
                        // },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Client Address',
                        viewName: 'clientAddress',
                        filterName: 'companyReferred.addressLine1',
                        // filter: {
                        //     type: 'text',
                        //     placeholder: 'Search',
                        //     onSubmit: header => {
                        //         sendRequest(evaluateFilter(header));
                        //     }
                        // },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Month Ended Commision for payment',
                        viewName: 'monthlyPayment',
                        // filter: {
                        //     type: 'text',
                        //     placeholder: 'Search',
                        //     onSubmit: header => {
                        //         sendRequest(evaluateFilter(header));
                        //     }
                        // },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'YTD Commission paid',
                        viewName: 'ytdPaid',
                        // filter: {
                        //     type: 'text',
                        //     placeholder: 'Search',
                        //     onSubmit: header => {
                        //         sendRequest(evaluateFilter(header));
                        //     }
                        // },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    }
                ],
                data: []
            }

            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: AffiliateService.getAllReportAproval,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err.message);
                    },
                    defaultFilters: {
                        size: 20,
                        page: 0,
                        commissionStatus: 'Approved',
                        sort: 'id,desc'
                    }
                }
            );

            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item) {
                    item.name = item.companyMarketing.name;
                    item.phone = `${item.companyMarketing.phone1} ${item.companyMarketing.phone2 ? ' / ' + item.companyMarketing.phone2 : ''}`;
                    item.clientName = `${item.companyReferred.companyName}`;

                    item.clientPhone = `${item.companyReferred.phone1} ${item.companyReferred.phone2 ? ' / ' + item.companyReferred.phone2 : ''}`;
                    item.clientAddress = {
                        type: 'multiLine',
                        list: [
                            item.companyReferred.addressLine1,
                            item.companyReferred.addressLine2,
                            `${item.companyReferred.location.state.name} ${item.companyReferred.location.code}  ${item.companyReferred.location.country.name}`
                        ]
                    };
                    item.commissionStatus = item.commissionStatus.toUpperCase()
                    item.ytdPaid = `${$filter('bbaCurrency')(item.ytdPaid, '')} `;
                    item.monthlyPayment = `${$filter('bbaCurrency')(item.monthlyPayment, '')}`;

                    tableData.data.push(item);
                });
            }

            this.tableData = tableData;
        }
    }
})()


// WEBPACK FOOTER //
// ./js/services/tables/affiliateTable/ApprovedReportTableService.js